// <pos-nav/> — 頂端導覽列
// see architecture.md#L580

class PosNav extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    window.addEventListener('hashchange', () => this.render());
  }

  render() {
    const hash = location.hash || '#/dashboard';
    const role = document.body.dataset.role || 'cashier';

    // QA 建議 #13：12 項擠一排眼花 → 分「營運（每天用）｜管理（owner 進階）」
    // 兩組間視覺分隔；窄螢幕橫向可捲。
    const OPS = [
      { href: '#/pos', label: '點餐', roles: ['owner','cashier'] },
      { href: '#/orders', label: '訂單', roles: ['owner','cashier','kitchen'] },
      { href: '#/reservations', label: '訂位', roles: ['owner','manager','cashier'] },
      { href: '#/my-shifts', label: '我的班表', roles: ['owner','manager','cashier','kitchen'] },
    ];
    const MGMT = [
      // 對外品牌統一名「小掌櫃」；see src/lib/branding.js
      { href: '#/xiaohong', label: '小掌櫃', roles: ['owner'] },
      { href: '#/xiaonuan', label: '今日推薦', roles: ['owner'] },
      { href: '#/menu', label: '菜單', roles: ['owner'] },
      { href: '#/scheduling', label: '排班', roles: ['owner'] },
      { href: '#/reports', label: '報表', roles: ['owner'] },
      { href: '#/staff', label: '員工', roles: ['owner'] },
      { href: '#/settings', label: '設定', roles: ['owner'] },
    ];
    const ops = OPS.filter((l) => l.roles.includes(role));
    const mgmt = MGMT.filter((l) => l.roles.includes(role));

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          background: var(--bg-surface);
          border-bottom: 1px solid var(--border);
          /* iOS 瀏海/靈動島 safe area：內容區 64px + 頂部安全區留白，避免 nav 疊在 status bar 下 */
          height: calc(64px + env(safe-area-inset-top, 0px));
          padding-top: env(safe-area-inset-top, 0px);
          box-sizing: border-box;
        }
        nav {
          display: flex;
          align-items: center;
          gap: var(--s-3);
          padding: 0 max(var(--s-5), env(safe-area-inset-left, 0px)) 0 max(var(--s-5), env(safe-area-inset-right, 0px));
          height: 64px;
          max-width: 100%;
          box-sizing: border-box;
        }
        .brand { font-family: var(--font-display); color: var(--brand-primary); flex-shrink: 0; }
        .links { display: flex; gap: var(--s-3); flex: 1; min-width: 0; }
        a {
          min-height: var(--touch-min);
          padding: 0 var(--s-3);
          color: var(--fg-muted);
          display: inline-flex;
          align-items: center;
          text-decoration: none;
          border-radius: var(--r-md);
          white-space: nowrap;
          flex-shrink: 0;
        }
        .links { overflow-x: auto; -webkit-overflow-scrolling: touch; scrollbar-width: none; }
        .links::-webkit-scrollbar { display: none; }
        .links__sep { display: inline-block; width: 1px; height: 20px; background: var(--border); margin: 0 var(--s-2); vertical-align: middle; flex-shrink: 0; }
        a[data-active="true"] {
          color: var(--brand-primary);
          background: var(--bg-elevated);
        }
      </style>
      <nav>
        <div class="brand">TAUKE POS</div>
        <div class="links">
          ${ops.map((l) => `
            <a href="${l.href}" data-active="${hash === l.href}">${l.label}</a>
          `).join('')}
          ${mgmt.length ? '<span class="links__sep"></span>' : ''}
          ${mgmt.map((l) => `
            <a href="${l.href}" data-active="${hash === l.href}">${l.label}</a>
          `).join('')}
        </div>
      </nav>
    `;
  }
}

customElements.define('pos-nav', PosNav);
